import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LockKey, SignIn } from "@phosphor-icons/react";
import { adminLogin, getAdminToken } from "../lib/admin";
import { FlycherLogo } from "../components/FlycherLogo";
import { Seo } from "../components/Seo";
import { toast, Toaster } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (getAdminToken()) nav("/admin", { replace: true });
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminLogin(email.trim(), password);
      toast.success("Welcome back, Captain ✈️");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-5 sky-bg"
      data-testid="admin-login-page"
    >
      <Seo title="Admin login" path="/admin/login" noindex />
      <Toaster theme="light" position="top-center" offset={20} />
      <form
        onSubmit={submit}
        className="w-full max-w-md card-surface rounded-3xl p-7 sm:p-9"
      >
        <FlycherLogo size={40} />
        <div className="mt-7 flex items-center gap-2">
          <span className="kicker">— Admin</span>
        </div>
        <h1 className="font-serif text-3xl sm:text-4xl mt-2 text-slate-900 leading-tight">
          Welcome back.
          <br />
          <span className="italic" style={{ color: "#2A7FB8" }}>
            Sign in to the cockpit.
          </span>
        </h1>
        <p className="text-sm text-slate-600 mt-3">
          Private analytics dashboard for Flycher operators.
        </p>

        <div className="mt-7 space-y-3">
          <input
            data-testid="admin-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@flycher.com"
            className="input-base h-12 text-base"
            autoFocus
          />
          <input
            data-testid="admin-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="input-base h-12 text-base"
          />
        </div>

        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="mt-6 w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-full text-sm font-semibold text-white shadow-lg shadow-orange-200/70 disabled:opacity-50"
          style={{ background: "#FF7E4D" }}
        >
          <SignIn size={16} weight="bold" />
          {busy ? "Signing in…" : "Sign in"}
        </button>

        <div className="mt-5 flex items-center justify-center gap-2 text-[11px] text-slate-500">
          <LockKey size={12} />
          End-to-end encrypted · bcrypt + JWT
        </div>
      </form>
    </div>
  );
}
